// @flow
import * as React from 'react';
import Box from 'sail/Box';
import Card from 'sail/Card';
import {CodeBlock} from 'docs/components';
import * as NoticeExamples from './examples/Notice';

type TailorExampleProps = {|
  component: string,
  children: React.Node,
  example: string,
|};

const componentToExamples = {
  Notice: NoticeExamples,
};

// This is a WIP. See http://go/tailor-docs-journal

export const TailorExample = ({
  component,
  children,
  example,
}: TailorExampleProps) => {
  const {rendered, source} =
    componentToExamples[component] && componentToExamples[component][example]
      ? componentToExamples[component][example]
      : {};

  if (!rendered || !source) {
    return null;
  }

  const codeBlock = (
    <CodeBlock filename="Source Code" language="jsx">
      {`${source}\n`}
    </CodeBlock>
  );

  if (!rendered) {
    return null;
  }

  const preview = (
    <Box>
      <Card radius="bottom" shadow="keyline">
        <Box padding={{all: 20}}>{rendered}</Box>
      </Card>
    </Box>
  );
  const dividerBottomRadius = 0;
  return (
    <Box className="ComponentExample" margin={{top: 24, bottom: 64}}>
      <Box className="ComponentExample-CodeContainer">{codeBlock}</Box>
      <Box
        background="gray50"
        divider={{color: 'light', width: 1, side: 'all'}}
        style={{
          margin: '0 -1px',
          borderBottomLeftRadius: dividerBottomRadius,
          borderBottomRightRadius: dividerBottomRadius,
        }}
      />
      {preview}
    </Box>
  );
};
